import React from "react";
import RenderFormList from "./RenderFormList";
import OptionBarServiceButtonWithForms from "./OptionBarServiceButtonWithForms";
const RenderNestedServicesWithForms = (props) => {
  const { options, isOpen, forms, children, icon, showInactive } = props;

  return (
    <ul className={isOpen ? "list-is-open" : "list-is-closed"}>
      {options &&
        options.map((option) => (
          <OptionBarServiceButtonWithForms
            key={option.serviceId}
            option={option}
            showInactive={showInactive}
            icon={icon}
            forms={[
              ...option.offlineForms,
              ...option.ddiForms,
              ...option.callLineForms,
            ]}
          />
        ))}
      {forms && forms.length > 0 && (
        <RenderFormList
          forms={forms}
          showInactive={showInactive}
          callingFunction={"fromService"}
        />
      )}
    </ul>
  );
};

export default RenderNestedServicesWithForms;
